import { createFileRoute } from '@tanstack/react-router';
import { PopoutPage } from '../../features/messaging';

/** The pop-out window's standalone route (same URL as `portal/messages/popout.$threadId.tsx`). */
export const Route = createFileRoute('/portal/messages/popout/$threadId')({
  component: function MessagePopoutRoute() {
    const { threadId } = Route.useParams();
    return <PopoutPage threadId={threadId} />;
  },
});
